import { IconButton } from '@mui/material';
import HelpOutlineIcon from 'assets/img/icons/HelpOutlineIcon';
import ClickableTooltip from './ClickableTooltip';

const TooltipIcon = ({ tooltip }: { tooltip: React.ReactNode; sx?: object }) => {
  return (
    <ClickableTooltip tooltipText={tooltip}>
      <IconButton sx={{ padding: '0' }}>
        <HelpOutlineIcon width={14} height={14} stroke="#6C727A80" />
      </IconButton>
    </ClickableTooltip>
  );
};

export default TooltipIcon;
